function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { formatWithCurrencyCode, formatPreferringSymbolsWhenKnown } from '../../currency-formatter';
import { getBulkPaymentDate } from '../../payment-utils';
import { formatRateAndCurrency } from '../../rate-formatter';
import { getClientName } from '../../tpps';
export function getPaymentDetails(payment) {
  var details = {
    paymentAmount: parsePaymentAmount(payment),
    creditAmount: parseCreditAmount(payment),
    debitAmount: parseDebitAmount(payment),
    id: payment.get('id'),
    isBulk: payment.channelId === 'OBPISPBB',
    isVrp: payment.channelId === 'OBVRP',
    isInternational: isInternational(payment),
    isBalanceTransfer: isBalanceTransfer(payment),
    isUpcoming: payment.getIn(['payload', 'upcoming']),
    pastPaymentDate: payment.getIn(['activity', 'modifiedAt'], payment.get('modifiedAt')),
    payeeRef: payment.getIn(['payload', 'paymentInformation', 'statementReference']),
    remittance: payment.getIn(['payload', 'paymentInformation', 'paymentDescription']),
    recipientName: payment.getIn(['payload', 'creditor', 'account', 'customerName']),
    statementReference: payment.getIn(['payload', 'paymentInformation', 'statementReference']),
    status: payment.getIn(['activity', 'status'], payment.get('status')),
    clientName: getClientName(payment),
    transactionRef: payment.getIn(['payload', 'paymentInformation', 'endToEndIdentification']),
    type: payment.getIn(['payload', 'type'], 'SINGLE_IMMEDIATE'),
    upcomingPaymentDate: payment.getIn(['payload', 'executionDate']),
    isInternalTransfer: payment.getIn(['payload', 'internalAccountTransfer']),
    valueDate: payment.getIn(['payload', 'valueDate'])
  };
  if (details.isBulk) {
    details = _objectSpread(_objectSpread({}, details), {}, {
      individualPayments: payment.getIn(['payload', 'paymentInstructions']).toArray(),
      fileReference: payment.getIn(['payload', 'fileReference'], 'bulk payment'),
      bulkPaymentDate: getBulkPaymentDate(payment)
    });
  }
  if (details.isInternational) {
    details = _objectSpread(_objectSpread({}, details), {}, {
      bankAddress: payment.getIn(['payload', 'internationalPaymentDetails', 'creditorAgentAddress'], []).map(function (line) {
        return line.trim();
      }),
      creditorAgentIdentification: payment.getIn(['payload', 'internationalPaymentDetails', 'creditorAgentIdentification']),
      creditorAgentScheme: payment.getIn(['payload', 'internationalPaymentDetails', 'creditorAgentScheme']),
      creditorCountryName: payment.getIn(['payload', 'internationalPaymentDetails', 'creditorCountryName'], ''),
      destinationCountryName: payment.getIn(['payload', 'internationalPaymentDetails', 'creditorAgentCountryName'], ''),
      exchangeRate: payment.getIn(['payload', 'internationalPaymentDetails', 'exchangeRateInformation', 'exchangeRateString']) || Number(payment.getIn(['payload', 'internationalPaymentDetails', 'exchangeRateInformation', 'exchangeRate'])),
      fee: payment.hasIn(['payload', 'internationalPaymentDetails', 'fee']) && parseAmount(payment.getIn(['payload', 'internationalPaymentDetails', 'fee'])),
      payeeAddress: payment.getIn(['payload', 'creditorAddress'], []).map(function (line) {
        return line.trim();
      }),
      isUrgent: payment.getIn(['payload', 'internationalPaymentDetails', 'isUrgent']),
      estimatedArrivalDate: payment.getIn(['payload', 'internationalPaymentDetails', 'pimsCreditDate']),
      foreignBankFee: payment.hasIn(['payload', 'internationalPaymentDetails', 'foreignBankFee']) && parseAmount(payment.getIn(['payload', 'internationalPaymentDetails', 'foreignBankFee'])),
      totalToPay: payment.hasIn(['payload', 'internationalPaymentDetails', 'totalToPay']) && parseAmount(payment.getIn(['payload', 'internationalPaymentDetails', 'totalToPay'])),
      purpose: payment.getIn(['payload', 'internationalPaymentDetails', 'purpose'])
    });
  }
  if (details.isBalanceTransfer) {
    details = _objectSpread(_objectSpread({}, details), {}, {
      balanceTransferDetails: payment.getIn(['payload', 'balanceTransferDetails']).toJS()
    });
  }
  if (details.isVrp) {
    var periodicLimits = payment.hasIn(['payload', 'controlParameters', 'periodicLimits']) ? payment.getIn(['payload', 'controlParameters', 'periodicLimits']).toJS() : [];
    details = _objectSpread(_objectSpread({}, details), {}, {
      sweeping: payment.getIn(['payload', 'sweeping']),
      validTo: payment.getIn(['payload', 'controlParameters', 'validTo']),
      validFrom: payment.getIn(['payload', 'controlParameters', 'validFrom']),
      maximumIndividualAmount: payment.getIn(['payload', 'controlParameters', 'maximumIndividualAmount']),
      maximumIndividualAmountCurrency: payment.getIn(['payload', 'controlParameters', 'maximumIndividualAmountCurrency']),
      maximumCumulativeAmount: payment.getIn(['payload', 'controlParameters', 'maximumCumulativeAmount']),
      maximumCumulativeAmountCurrency: payment.getIn(['payload', 'controlParameters', 'maximumCumulativeAmountCurrency']),
      maximumCumulativeNumberOfPayments: payment.getIn(['payload', 'controlParameters', 'maximumCumulativeNumberOfPayments']),
      maxNumberOfPayments: periodicLimits.filter(function (periodicLimit) {
        return periodicLimit.numberOfPayments;
      }),
      maxTotalAmount: periodicLimits.filter(function (periodicLimit) {
        return periodicLimit.amount && periodicLimit.currency;
      }),
      merchantName: payment.getIn(['payload', 'controlParameters', 'merchantName'])
    });
  }
  return details;
}
function isInternational(paymentDto) {
  return paymentDto.getIn(['payload', 'type'], '').indexOf('INTERNATIONAL') > -1;
}
function isBalanceTransfer(paymentDto) {
  return paymentDto.getIn(['payload', 'type'], '') === 'BALANCE_TRANSFER';
}
function parsePaymentAmount(paymentDto) {
  return parseAmount(paymentDto.get('payload'));
}
function parseDebitAmount(payment) {
  return isInternational(payment) ? parseAmount(payment.getIn(['payload', 'internationalPaymentDetails', 'debitAmount'])) : parsePaymentAmount(payment);
}
function parseCreditAmount(payment) {
  return isInternational(payment) ? parseAmount(payment.getIn(['payload', 'internationalPaymentDetails', 'creditAmount'])) : parsePaymentAmount(payment);
}
function parseAmount(amountDto) {
  return {
    amount: amountDto.get('amountString') || Number(amountDto.get('amount')),
    currency: amountDto.get('currency')
  };
}
export function createMoneyFormatter(paymentDetails) {
  return function formatMoney(_ref) {
    var currency = _ref.currency,
      amount = _ref.amount;
    return paymentDetails.isInternational ? formatWithCurrencyCode(amount, currency) : formatPreferringSymbolsWhenKnown(amount, currency);
  };
}
export function getConversionRateSummary(paymentDetails, formatMoney) {
  if (!paymentDetails.exchangeRate || paymentDetails.creditAmount.currency === paymentDetails.debitAmount.currency) {
    return null;
  }
  var debitAmount = paymentDetails.debitAmount;
  var creditAmount = paymentDetails.creditAmount;
  var unitAccountCurrency = formatMoney({
    amount: 1,
    currency: debitAmount.currency
  });
  var conversionAmountPaymentCurrency = formatRateAndCurrency({
    rate: paymentDetails.exchangeRate,
    currency: creditAmount.currency
  });
  var convertedAmountString = paymentDetails.paymentAmount.currency === creditAmount.currency ? "Debit amount ".concat(formatMoney(debitAmount)) : "Credit amount ".concat(formatMoney(creditAmount));
  return "".concat(convertedAmountString, " (").concat(unitAccountCurrency, " = ").concat(conversionAmountPaymentCurrency, ")");
}